import React, { useEffect, useState } from "react";
import PostItem from "../home/patsPosts_item";
import { useAlert } from "react-alert";
import InfiniteScroll from "react-infinite-scroll-component";
function ProfileAll(props) {
  const [items, setItems] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(true);
  const [refresh, setRefresh] = useState(0);
  const alert = useAlert();

  useEffect(() => {
    setItems([]);
    fetchallInitialData();
  }, [refresh, props.id]);

  const fetchallInitialData = () => {
    fetch(
      process.env.REACT_APP_API_URL +
      "api/posts/userpost/" +
      props.id +
      "/" +
      limit +
      "/0"
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setItems(data.posts);
          setOffset(limit);
        } else {
          alert.error(data.message);
        }
      });
  };

  const fetchallMoreData = () => {
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    // setTimeout(() => {
    //   setItems(items.concat(Array.from({ length: 20 })));
    // }, 1500);
    fetch(
      process.env.REACT_APP_API_URL +
      "api/posts/userpost/" +
      props.id +
      "/" +
      limit +
      "/" +
      offset
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setItems(items.concat(data.posts));
          if (data.posts.length < limit) {
            setMore(false);
          } else {
            setOffset(offset + limit);
          }
        } else {
          alert.error(data.message);
        }
      });
  };
  return (
    <InfiniteScroll
      dataLength={items.length}
      next={fetchallMoreData}
      hasMore={more}
      loader={<h4>Loading...</h4>}
      refreshFunction={fetchallInitialData}
    >
      {items.map((element, index) => (
        <PostItem data={element} key={index} />
      ))}
    </InfiniteScroll>
  );
}
export default ProfileAll;
